export default {
  independentMarketing: {
    common: {
      requestFailed: '接口请求失败',
      hintSelect: '请选择',
      hintInput: '请输入',
      submit: '提交',
      cancel: '取消',
      confirm: '确定',
    },
    agreement: {
      title: 'Autel自主营销经销商注册协议',
      nextBtn: '下一步',
      getAgreementFailed: '获取协议内容失败',
    },
    successPage: {
      title: '您的申请信息已提交成功，审核结果将在15个工作日内发送至您的邮箱$1，请注意及时查收。',
      subTitle: '$1s 后自动返回首页',
    },
    applyTitle: '您正在申请成为Autel自主营销经销商，请如实填写以下信息：',
    companyName: '企业名称',
    companyTax: '企业税号',
    userCountry: '所在国家',
    legalPerson: '法人姓名',
    contactEmail: '联系人邮箱',
    contactEmailTips: '此邮箱将会收到审核结果邮件，且审核通过后将被用作自主经销商管理系统登录账号。',
    corporateIdentity: '法人身份证件',
    uploadTips: 'JPG、JPEG、PNG、PDF，不超过20M',
    businessLicense: '企业营业执照',
    emailErrorTips: '请输入正确的邮箱',
    uploadPic: '上传照片',
    picMaxLimit: '图片最大支持20M，请重新选择',
  },
};
